module.exports = __webpack_public_path__ + "static/spring23_flyer-35bc84ff19feb0d53b33d464170d6362.png";